<template>
  <!-- 
  Tips: 
    为了兼容nick和roleList的数据同时存在，保存了两个DOM节点方便处理，
    后期可以在当前的组件维护一个数据源
 -->
  <div :class="bindClass">
    <!-- 单个名称显示 -->
    <div v-show="isRenderUserName" class="single">
      <div class="user-name">
        <p :style="titleColor">
          {{ renderLanguage.nickName }}:<span>{{ isRenderUserName }}</span>
        </p>
      </div>
    </div>
    <!-- 多个名称显示 -->
    <div v-show="isUserNameList" class="list">
      <div
        class="user-name"
        :style="bindUserNameListStyle"
        @click="isVisibility = !isVisibility"
      >
        <p :style="currentUserNnameColor">
          {{ selecteds.roleName }}
        </p>
        <MBIcon
          classNames="user-icon"
          name="icon-black-arrow"
          :size="iconSize"
          :color="iconColor"
          :opacity="0.5"
        />
        <div
          class="drop-down-names"
          :style="bindUserNameStyle"
          v-show="isVisibility"
        >
          <div class="tips">
            <span :style="fontColor">{{ renderLanguage.nickNameTips }}</span>
            <MBIcon
              classNames="tips-icon"
              name="icon-black-arrow"
              :size="iconSize"
              :color="iconColor"
              :opacity="0.5"
            />
          </div>
          <div
            v-for="item in userNameList"
            :key="item.roleId"
            :class="[
              'item-name',
              selecteds.roleId === item.roleId ? 'active' : '',
            ]"
            :style="fontColor"
            @click="handleuUerName(item)"
          >
            {{ item.roleName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MBIcon from '@/components/MBIcon'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapState, mapMutations } from 'vuex'
  export default {
    name: 'NickName',
    mixins: [styleConfiguration],
    props: {},
    components: {
      MBIcon,
    },
    data() {
      return {
        userNameList: [],
        username: '',
        selecteds: {},
        isVisibility: false,
      }
    },
    computed: {
      ...mapState(['gameName', 'isDesktop', 'isMobile']),
      ...mapState('detail', ['nickName']),

      titleColor() {
        return this.mFontColor
      },
      fontColor() {
        return this.mFontColor
      },
      iconColor() {
        return this.mFontColor.color
      },

      iconSize() {
        return this.isDesktop ? 22 : 40
      },

      currentUserNnameColor() {
        return this.mFontColor
      },

      bindUserNameStyle() {
        return this.skuBackColor
      },

      isUserNameList() {
        return this.userNameList.length && this.userNameList.length > 1
      },

      bindUserNameListStyle() {
        return this.skuBackColor
      },

      bindClass() {
        const defaultClass = ['user-content', this.gameName]
        let device = []

        if (this.isDesktop) {
          device.push(`${defaultClass[0]}-desktop`)
        }
        if (this.isMobile) {
          device.push(`${defaultClass[0]}-mobile`)
        }

        if (this.isVisibility) {
          device.push(`${defaultClass[0]}-open`)
        }

        return defaultClass.concat(device)
      },

      isRenderUserName() {
        if (this.userNameList.length === 1) {
          return this.userNameList[0].roleName
        }
        if (this.username) {
          return this.username
        }
        return ''
      },
      renderLanguage() {
        let nickName = this.$t(`publicDetails.uid_nickname`)
        let nickNameTips = this.$t(`publicDetails.uid_nickname_title`)

        return {
          nickName,
          nickNameTips,
        }
      },
    },

    watch: {
      nickName: {
        handler(namelist) {
          // 区分多角色
          if (Array.isArray(namelist) && namelist.length) {
            this.userNameList = namelist

            this.selecteds = this.userNameList[0]
            this['detail/setUserRoles'](this.userNameList[0])
            this.username = ''
            return
          }

          // nickName
          if (!!namelist && typeof namelist === 'string') {
            this.userNameList = []
            this.username = namelist
            return
          }

          this.userNameList = []
          this.username = ''
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      ...mapMutations(['detail/setUserRoles']),
      handleuUerName(item) {
        this.selecteds = item
        this['detail/setUserRoles'](item)
      },
    },
  }
</script>
<style scoped lang="scss" src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
</style>
